export default __webpack_public_path__ + "static/media/table_NPC_Cn.22d931ef.webp";